import { FC } from "react";
import Link from "next/link";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import ImageComponent from "../image";
import { resolveProductImageSources } from "utils/product-image";
import DiscountBadge from "./discout-badge";
import { useLayoutContext } from "@context/layout";
import { ICard } from "./types";

const CheckBoxCard: FC<ICard & { href: string }> = ({
  svg_image,
  png_image,
  title,
  href,
  festival,
  price,
  svg_featured_image,
  png_featured_image,
  webp_image,
  webp_featured_image,
}) => {
  const imageSources = resolveProductImageSources({
    svg_image,
    png_image,
    webp_image,
    svg_featured_image,
    png_featured_image,
    webp_featured_image,
  });
  const { subscriptionData } = useLayoutContext();
  const hasActiveSubscription = Boolean(subscriptionData?.is_active);
  const salePrice = festival?.price_on_festival;
  const isPercentDiscount = festival?.is_percent;
  const discount = hasActiveSubscription ? undefined : festival?.discount_value;
  return (
    <div className="rounded-8 border  border-fds-cart hover:shadow-brand-md  gap-x-8 flex flex-col  px-2.5   sm:p-2">
      <Link href={href} prefetch={false}>
        <div className="flex gap-2">
          <input type="radio" />
          <div className="block w-26 aspect-video relative">
            <ImageComponent
              className="object-cover"
              quality={100}
              loading="lazy"
              fill
              alt="course"
              src={imageSources.src}
              fallbackSrcs={imageSources.fallbackSrcs}
            />
          </div>
        </div>
        <div className="flex sm:flex-row items-center justify-between flex-col">
          <p className="title-md-demibold text-fds-primary">{title}</p>
          <p className="text-fds-danger body-xxsm">
            تخفیف{" "}
            <span className="title-md-demibold">
              {separateMoneyNumbers(toFarsiNumber(salePrice))}
            </span>{" "}
            تومان
          </p>
          <p className="title-md-demibold text-fds-primary">
            {separateMoneyNumbers(toFarsiNumber(price))}
            <span className="text-fds-secondary ">تومان</span>
          </p>
          {isPercentDiscount && discount && (
            <DiscountBadge discount={discount} />
          )}
        </div>
        <button></button>
      </Link>
    </div>
  );
};
export default CheckBoxCard;
